/*
 * Public API Surface of client-prospect
 */

export * from './lib/client-prospect.service';
export * from './lib/client-prospect.component';
export * from './lib/client-prospect.module';
